<template>
  <div class="index">
    <van-nav-bar
        title="筛选客户"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
<!--        @click-left="onClickLeft"-->
<!--        @click-right="onClickRight"-->
    <div class="content">
      <div class="item">
        <div class="list-item">
          <div class="item-title">
            所属客服
          </div>
          <div @click="$refs.employee.$show(StandbyStaffList,'max')" class="item-content">

            {{ StandbyStaffList.length > 0 ? String(StandbyStaff) : '请选择客服' }}
            <van-icon name="arrow-down"/>
          </div>
        </div>
        <div class="list-item">
          <div class="item-title">
            企业标签
          </div>
          <div @click="$refs.tags.$show(tagsList)" style="margin-top: 10px;">
            <van-button @click="" style="height: 30px;" plain type="info">选择标签</van-button>
          </div>
          <div v-if="tagsList.length > 0" style="margin-top: 10px;">
            <van-tag style="margin: 0 5px" v-for="(item,index) in tagsList" closeable plain  size="medium" type="primary" @close="tagsList.splice(index,1)">{{ item.name }}</van-tag>
          </div>
        </div>
        <div class="list-item">
          <div class="item-title">
            添加时间
          </div>
          <div class="item-content" @click="datePickerVisible = true">
            <div style="flex: 1;text-align: center">{{ sTime ? sTime.slice(0, 10) : '开始日期' }}</div>
            -
            <div style="flex: 1;text-align: center">{{ endTime ? endTime.slice(0, 10) : '结束日期' }}</div>
          </div>
        </div>
        <div class="list-item">
          <div class="item-title">
            添加渠道
          </div>
          <div>
            <div v-for="(item,index) in qcode" :key="index" @click="activeq(index)" :class="{qd: item.chose}" class="item-content item-lable">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="list-item">
          <div class="item-title">
            客户性别
          </div>
          <div>
            <div @click="codew = 3" :class="{qd: codew == 3}" class="item-content item-lable filter-option">
              不限
            </div>
            <div @click="codew = 0" :class="{qd: codew == 0}" class="item-content item-lable filter-option">
              未知
            </div>
            <div @click="codew = 1" :class="{qd: codew == 1}" class="item-content item-lable filter-option">
              男
            </div>
            <div @click="codew = 2" :class="{qd: codew == 2}" class="item-content item-lable filter-option">
              女
            </div>
          </div>
        </div>
        <div class="list-item">
          <div class="item-title">
            流失状态
          </div>
          <div>
            <div @click="lose = 0" :class="{qd: lose == 0}" class="item-content item-lable">
              不限
            </div>
            <div @click="lose = 1" :class="{qd: lose == 1}" class="item-content item-lable">
              未流失
            </div>
            <div @click="lose = 2" :class="{qd: lose == 2}" class="item-content item-lable">
              已流失
            </div>
          </div>
        </div>
        <div style="    justify-content: space-around;
    width: 100%;display: flex;    justify-content: space-between;">
          <van-button @click="resetFilters" style="width: 35%;" block type="default">清空筛选</van-button>
          <van-button @click="customer" style="width: 35%;" block type="info">查看客户</van-button>
        </div>
      </div>

    </div>
    <!--  选择客户  -->
    <addCustomer ref="customer"/>
    <!--  选择标签  -->
    <addTags ref="tags" @change="tagsChose"/>
    <van-calendar
        v-model="datePickerVisible"
        color="#1989fa"
        type="range"
        :min-date="new Date('2000-01-01')"
        :max-date="new Date()"
        @confirm="choseDateRange"
    />

    <employeeIndex ref="employee" @change="userChange"/>
  </div>
</template>

<script>
import addCustomer from "../index/components/addCustomer";
import addTags from "../channelCode/components/customerLabel";
import employeeIndex from "../channelCode/components/employeeIndex";
import { clearCustomerListState } from './listState'

export default {
  components: {
    addCustomer,
    addTags,
    employeeIndex
  },
  data() {
    return {
      // 文字
      message: '',
      // tbas切换
      tabsChose: 0,
      // 员工
      StandbyStaffList: [],
      StandbyStaff:[],
      tagsList: [],
      sTime: '',
      endTime: '',
      datePickerVisible: false,

      //渠道
      qcode: [{chose: false,addWay:2,name: '搜索手机号'},{chose: false,addWay:5,name: '手机通讯录'},{chose: false,addWay:8,name: '安装第三方应用时添加的客服人员'},{chose: false,addWay:202,name: '管理员/负责人分配'},{chose: false,addWay:1003,name: '裂变引流'}],
      // 性别
      codew: 3,
      lose: 0
    }
  },
  watch: {},
  created() {
    this.restoreFilters()
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    // 员工
    userChange(data, info) {
      this.StandbyStaffList = data
      this.StandbyStaff = data.map(i=>i.name)
    },
    tagsChose(data){
      this.tagsList = data
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    choseDateRange(date) {
      const [start, end] = date
      this.sTime = `${this.formatDate(start)} 00:00:00`
      this.endTime = `${this.formatDate(end)} 23:59:59`
      this.datePickerVisible = false
    },
    activeq(i){
      const selected = !this.qcode[i].chose
      this.qcode.forEach(item=>{
        item.chose = false
      })
      this.qcode[i].chose = selected
    },
    restoreFilters() {
      const raw = this.$route.query.content
      if (!raw || typeof raw !== 'string') return
      try {
        const filter = JSON.parse(raw)
        this.StandbyStaffList = Array.isArray(filter.employees) ? filter.employees : []
        this.StandbyStaff = this.StandbyStaffList.map(item => item.name)
        this.tagsList = Array.isArray(filter.tagItems) ? filter.tagItems : []
        this.sTime = filter.startTime || ''
        this.endTime = filter.endTime || ''
        this.codew = [0, 1, 2, 3].includes(Number(filter.gender)) ? Number(filter.gender) : 3
        this.lose = [0, 1, 2].includes(Number(filter.status)) ? Number(filter.status) : 0
        this.qcode.forEach(item => { item.chose = String(item.addWay) === String(filter.channel || '') })
      } catch (error) {
        this.resetFilters()
      }
    },
    resetFilters() {
      this.StandbyStaffList = []
      this.StandbyStaff = []
      this.tagsList = []
      this.sTime = ''
      this.endTime = ''
      this.codew = 3
      this.lose = 0
      this.qcode.forEach(item => { item.chose = false })
    },
    customer(){
      const selectedChannel = this.qcode.find(item => item.chose)
      const content = {
        employeeId: this.StandbyStaffList.length ? this.StandbyStaffList[0].id : 0,
        employees: this.StandbyStaffList,
        tags: this.tagsList.map(item => item.id),
        tagItems: this.tagsList,
        startTime: this.sTime,
        endTime: this.endTime,
        channel: selectedChannel ? selectedChannel.addWay : '',
        gender: this.codew,
        status: this.lose
      }
      clearCustomerListState()
      this.$router.replace({
        path: "/customer",
        query:{
          tab: 'customer',
          content: JSON.stringify(content)
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
/deep/.van-nav-bar__content{
  background: #2b63cd;
  color: #fff;
}
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
/deep/.van-nav-bar__text{
  color: #fff;
}
/deep/.van-nav-bar__title{
  color: #fff;
}
.index {
  font-size: 14px;
  height: 100%;
  background: #F1f2f5;

  p {
    margin: 0 !important;
  }
  .qd{
    color: #1890ff!important;
    border-color: #1890ff!important;
    background-color: #f3f9ff!important;
  }
  .content {
    height: 92%;

    img {
      width: 22px;
      height: 22px;
    }

    padding: 12px 16px;

    .item {
      background: #fff;
      padding: 20px 15px;
      height: 100%;
      overflow: auto;
      padding-bottom: 20px;
      .list-item {
        margin-bottom: 10px;
      }

      .item-title {
        font-weight: bold;
      }

      .item-content {
        width: 100%;
        /* background: red; */
        border: 1px solid #E5E6E7;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
        border-radius: 7px;
        margin-top: 10px;
      }

      .item-lable {
        display: inline-block;
        width: auto;
        align-items: center;
        line-height: 36px;
        margin: 10px 3px;
        border-radius: 0;
      }
      .filter-option {
        padding: 0 18px;
      }
    }
  }

  .bottom-button {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 20px;
    justify-content: space-around;
    width: 100%;
  }
}
</style>
